import React from 'react';
import { Users, TrendingDown, Clock, DollarSign } from 'lucide-react';
import ImageSlider from './ImageSlider';

const ValuePropositionSection = () => {
  return (
    <section className="py-20 px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Practice Dashboard: Add-On That Replaces{' '}
            <span className="text-blue-600">1 Full-Time Admin Employee</span>
          </h2>
          
          <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
            You likely have an admin pulling and tweaking reports from Practice CS—or maybe you're doing it yourself. 
            Practice Dashboard automates that workload, helping you escape this trap.
          </p>
        </div>
        
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-8">
            <div className="flex items-start space-x-4">
              <div className="bg-red-100 rounded-full p-3">
                <Users className="w-6 h-6 text-red-600" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Manual Admin Work</h3>
                <p className="text-gray-600">Hours spent pulling reports, manual data entry, and repetitive tasks</p>
              </div>
            </div>
            
            <div className="flex items-start space-x-4">
              <div className="bg-red-100 rounded-full p-3">
                <Clock className="w-6 h-6 text-red-600" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Time Consuming</h3>
                <p className="text-gray-600">Delayed reports and manual updates that slow down decision making</p>
              </div>
            </div>
            
            <div className="flex items-start space-x-4">
              <div className="bg-red-100 rounded-full p-3">
                <DollarSign className="w-6 h-6 text-red-600" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">High Cost</h3>
                <p className="text-gray-600">Full-time admin salary plus overhead costs for manual processes</p>
              </div>
            </div>
            
            <div className="bg-blue-50 rounded-lg p-6">
              <div className="text-center mb-4">
                <div className="flex items-center justify-center space-x-3 mb-4">
                  <TrendingDown className="w-8 h-8 text-blue-600" />
                  <h3 className="text-xl font-bold text-gray-900">Practice Dashboard Solution</h3>
                </div>
                
                <div className="space-y-3">
                  <div className="flex items-center space-x-3">
                    <div className="bg-green-500 rounded-full w-2 h-2"></div>
                    <span className="text-gray-700">Eliminates manual report generation</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="bg-green-500 rounded-full w-2 h-2"></div>
                    <span className="text-gray-700">Real-time data updates</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="bg-green-500 rounded-full w-2 h-2"></div>
                    <span className="text-gray-700">Saves 40+ hours per week</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="bg-green-500 rounded-full w-2 h-2"></div>
                    <span className="text-gray-700">Reduces admin overhead by 80%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <ImageSlider />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ValuePropositionSection;